import React from "react"

/**
 * Refetch loading chip for v2 tables. Render inside a `position-relative` ancestor
 * (e.g. `TableWithPagination` root), placed `bottomPx` from the bottom of that box.
 *
 * @param {{ show: boolean, bottomPx: number }} props
 */
export default function V2TableRefetchLoader({ show, bottomPx }) {
    if (!show) {
        return null
    }
    return (
        <div
            className="position-absolute d-flex align-items-center gap-2 px-3 py-2 shadow rounded
                border bg-white"
            style={{
                zIndex: 6,
                bottom: `${bottomPx}px`,
                right: "1.25rem",
            }}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className="spinner-border spinner-border-sm text-primary" />
            <span className="text-secondary" style={{ fontSize: "0.875rem" }}>Loading…</span>
        </div>
    )
}
